import { RequestProvider } from '@/shared/providers/request.provider';
import { ErrorProvider } from '@/shared/providers/errors.provider';
import { STAFF_API } from '../values/staff.values'
import {API_VARIABLES} from '../values/staff.values'

class StaffServiceClass {

  /* Get Methods */
  public findPerson(email): Promise<any> {
    try {
      let req = STAFF_API.FIND_PERSON;
      req = req.replace(API_VARIABLES.EMAIL, encodeURIComponent(email.toString()));
      return RequestProvider.get(req)
    } catch (error) {
      throw ErrorProvider.getError(error.error);
    }
  }

  getUsersByOrganizationId(orgId: number, page: number = 0, pageSize: number = 100, filters = 'SDA,SA,TEACHER,STUDENT') {
    try {
      const req = `${STAFF_API.GET_ORGANIZATION_USERS}${filters}`
        .replace(API_VARIABLES.ORGANIZATION_ID,orgId.toString());

      return RequestProvider.get(req, {
        page,
        pageSize
      });
    } catch (error) {
      throw ErrorProvider.getError(error.error);
    }
  }

  searchUsersInOrganization(orgId:number, keyword: string, userTypes: string, page: number, pageSize: number){
    try {
      let body = {
        keyword,
        userTypes,
        page,
        pageSize
      }
      let req = STAFF_API.SEARCH_USERS_ORGANIZATION.replace(API_VARIABLES.ORGANIZATION_ID,orgId.toString());
      return RequestProvider.get(req, body)
    } catch (error) {
      throw ErrorProvider.getError(error.error);
    }
  }

  getUnregisteredUsers(page:number=0,pageSize:number=100){
    try {
      let req = STAFF_API.GET_UNREGISTERED_USERS;
      let body = {
        page,
        pageSize
      }
      return RequestProvider.get(req, body)
    } catch (error) {
      throw ErrorProvider.getError(error.error);
    }
  }

  searchUnregisteredUsers(keyword: string, userType: string, page:number, pageSize: number){
    try {
      let req = STAFF_API.SEARCH_UNREGISTERED_USERS;
      let body = {
        keyword,
        userType,
        page,
        pageSize
      }
      return RequestProvider.get(req, body)
    } catch (error) {
      throw ErrorProvider.getError(error.error);
    }
  }

  /* Post Methods */
  public inviteUser(body, orgId): Promise<any> {
    try {
      let req = STAFF_API.INVITE_USER.replace(API_VARIABLES.ORGANIZATION_ID,orgId.toString());
      return RequestProvider.post(req, body)
    } catch (error) {
      throw ErrorProvider.getError(error.error);
    }
  }

  public removeUserFromOrganization(id:number): Promise<any> {
    try {
      let req = STAFF_API.REMOVE_USER_FROM_ORGANIZATION.replace(API_VARIABLES.ID,id.toString());
      return RequestProvider.remove(req)
    } catch (error) {
      throw ErrorProvider.getError(error.error);
    }
  }

  public getZipcode(zipcode): Promise<any> {
    return new Promise((resolve, reject) => {
      let req = STAFF_API.GET_ZIPCODE;
      req = req.replace(API_VARIABLES.ZIPCODE, zipcode.toString());
      RequestProvider.get(req)
      .then((res: any) => {
        resolve(res.data);
      })
      .catch(() => {
        reject();
      })
    });
  }

  public getCountries(): Promise<any> {
    return new Promise((resolve, reject) => {
      let req = STAFF_API.GET_COUNTRIES;
      RequestProvider.get(req)
      .then((res: any) => {
        resolve(res.data);
      })
      .catch(() => {
        reject();
      })
    });
  }


}

export const StaffService = new StaffServiceClass();